/*
 * This code was generated with assistance from GitHub Copilot.
 * De-bundled from react-dxd-components@0.1.33 compiled dist/index.js (webpack module id 13).
 */
/* eslint-disable jsx-a11y/href-no-hash */
import * as React from 'react';
import type { HTMLAttributes } from 'react';
import { useRef, useState } from 'react';
import classNames from './classnames-vendor';
import { useOnClickOutside } from './useOnClickOutsideConstants';
import { NavigationItem } from './NavigationItemConstants';

export interface SiteNavigationItemProps extends HTMLAttributes<HTMLDivElement> {
  item: NavigationItem;
  index: number;
  active?: boolean;
  className?: string;
}

const SiteNavigationItem = ({
  item,
  index,
  active = false,
  className,
  ...otherProps
}: SiteNavigationItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const subItems = item.subItems || [];
  const hasSubMenu = subItems.length > 0;

  const classes = classNames(
    'SiteNav-item',
    {
      'is-active': active,
      'has-subMenu': hasSubMenu,
      'is-open': isOpen,
    },
    className
  );

  useOnClickOutside(ref, () => setIsOpen(false));

  if (hasSubMenu) {
    const toggleSubMenu = () => setIsOpen((prevIsOpen) => !prevIsOpen);

    return (
      <div
        id={`subMenu-${item.title}`}
        className={classes}
        data-click-outside
        ref={ref}
        {...otherProps}
      >
        <button
          type="button"
          data-href={`#subMenu${index}`}
          tabIndex={index}
          className="SiteNav-itemLink"
          aria-haspopup="true"
          aria-expanded={isOpen}
          onClick={toggleSubMenu}
        >
          <span className="SiteNav-subMenuToggle">Back</span>
          <span className="SiteNav-itemLinkText">{item.title}</span>
        </button>
        <ul className="SiteNav-subMenu">
          {subItems.map((subitem) => (
            <li key={subitem.title}>
              <a href={subitem.href} onClick={subitem.onClick} className="SiteNav-itemLink">
                {subitem.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className={classes} {...otherProps}>
      <a href={item.href} onClick={item.onClick} tabIndex={index} className="SiteNav-itemLink">
        <span className="SiteNav-itemLinkText" id="">
          {item.title}
        </span>
      </a>
    </div>
  );
};

export default SiteNavigationItem;


